import PuzzleService from '_services/rest/modules/puzzle';
import Events from '_utils/events';
import { _LOAD_MODEL_ } from './components/PuzzleModel';

export default {
  state: {
    print: false,
    puzzle: null,
    printAnswer: false,
    printQuestion: false,
    puzzleCell: null,
    puzzleList: null,
    arrowPositions: null,
    questionSizes: null,
    arrowDirections: null,
    answerDirections: null,
  },
  mutations: {
    setArrowDirections(state, response) {
      state.arrowDirections = response;
    },
    setArrowPositions(state, response) {
      state.arrowPositions = response;
    },
    setAnswerDirections(state, response) {
      state.answerDirections = response;
    },
    setQuestionSizes(state, response) {
      state.questionSizes = response;
    },
    setPuzzleList(state, response) {
      state.puzzleList = response;
    },
    setPuzzle(state, puzzle) {
      state.puzzle = puzzle;
    },
    setPuzzleCell(state, cell) {
      state.puzzleCell = cell;
    },
    setPrintPuzzle(state, print) {
      state.print = print;
    },
    setPrintAnswerPuzzle(state, printAnswer) {
      state.printAnswer = printAnswer;
    },
    setPrintQuestionPuzzle(state, printQuestion) {
      state.printQuestion = printQuestion;
    },
  },
  actions: {
    getArrowDirections({ commit }) {
      PuzzleService.getArrowDirections()
        .then(response => {
          commit('setArrowDirections', response);
        });
    },
    getArrowPositions({ commit }) {
      PuzzleService.getArrowPositions()
        .then(response => {
          commit('setArrowPositions', response);
        });
    },
    getAnswerDirections({ commit }) {
      PuzzleService.getAnswerDirections()
        .then(response => {
          commit('setAnswerDirections', response);
        });
    },
    getQuestionSizes({ commit }) {
      PuzzleService.getQuestionSizes()
        .then(response => {
          commit('setQuestionSizes', response);
        });
    },
    getPuzzle({ commit }, id) {
      PuzzleService.getPuzlleById(id)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
          commit('setPuzzle', response);
        });
    },
    getPuzzleList({ commit }, params) {
      PuzzleService.getPuzlles(params)
        .then(response => {
          commit('setPuzzleList', response);
        });
    },
    setPuzzle({ commit }, model) {
      commit('setPuzzle', model);
    },
    setPuzzleCell({ commit }, cell) {
      commit('setPuzzleCell', cell);
    },
    setPrintPuzzle({ commit }, print) {
      commit('setPrintPuzzle', print);
    },
    setPrintAnswerPuzzle({ commit }, printAnswer) {
      commit('setPrintAnswerPuzzle', printAnswer);
    },
    setPrintQuestionPuzzle({ commit }, printQuestion) {
      commit('setPrintQuestionPuzzle', printQuestion);
    },
  },
};
